<span class="hint-text">{{ item.title }}</span>



// WEBPACK FOOTER //
// ./src/app/core/components/navigation/vertical/nav-subheader/nav-vertical-subheader.component.html